export const GET_SUGGESTIONS_V4 = '/merch/search/api/v4/suggest';

export enum SearchBarEvents {
  ClearedText = 'Search Bar Cleared Text',
  Focused = 'Search Bar Focused',
  GoClicked = 'Go Clicked',
  NoResults = 'No Results',
  PressedEnter = 'Pressed Enter',
  RemovedRecentSearch = 'Removed Recent Search',
  SuggestionClicked = 'Suggestion Clicked',
  Viewed = 'Suggestions Viewed'
}

export enum SearchType {
  DefaultSuggestion = 'DefaultSuggestion',
  SavedSearch = 'SavedSearch',
  RecentSearch = 'RecentSearch',
  TextSearch = 'TextSearch'
}

export const noSelectedSuggestion = {
  href: '/cars',
  text: ''
};

export const priceDropRestrictedStates = [
  'AR',
  'CA',
  'CT',
  'IL',
  'LA',
  'OR',
  'TX',
  'UT'
];
